import {
    GET_PROPERTY,
    CLEAR_PROPERTY_FIELDS,
    SET_PROPERTY_LOADING,
    REMOVE_PROPERTY_LOADING,
    GET_PROPERTY_CHART,
    SET_PROPERTY_CHART_LOADING,
    UPDATE_PROPERTY_SIX_PART_FILE,
    SET_PROPERTY_FIELDS,
    SET_PROPERTY_OLD_VALUE,
    REMOVE_PROPERTY_OLD_VALUE,
    SET_PROPERTY_ACCESS,
    SET_PROPERTY_UTILITY_VENDORS,
    PROPERTY_UPDATED
} from "../../types";

const initialState = {
    reactAPI: true, // This serves the purpose of differentia from React and Blade Server side.
    loading: true, // Initit loading state
    updated: false, // Initit loading state
    chartData: {}, // contains chart data
    chartLoading: false,
    canUserView: false,
    propertyData: {},
    propertyFields: {},
    oldValue: ""
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_PROPERTY_LOADING:
            return {
                ...state,
                loading: true
            };
        case REMOVE_PROPERTY_LOADING:
            return {
                ...state,
                loading: false
            };
        case PROPERTY_UPDATED:
            return {
                ...state,
                updated: payload
            };
        case SET_PROPERTY_ACCESS:
            return {
                ...state,
                canUserView: payload
            };
        case SET_PROPERTY_CHART_LOADING:
            return { ...state };

        case GET_PROPERTY:
            return {
                ...state,
                propertyData: { ...payload }
            };

        case SET_PROPERTY_UTILITY_VENDORS:
            return {
                ...state,
                propertyData: {
                    ...state.propertyData,
                    utility_vendors: payload
                }
            };
        case SET_PROPERTY_FIELDS:
            return {
                ...state,
                propertyFields: { ...payload }
            };
        case CLEAR_PROPERTY_FIELDS:
            console.log("Clearing property data.")
            return {
                ...state,
                propertyFields: {}
            };
        case GET_PROPERTY_CHART: {
            return {
                ...state,
                chartData: payload
            };
        }

        //	Double check if we are using this method
        case UPDATE_PROPERTY_SIX_PART_FILE:
            return {
                ...state,
                propertyData: {
                    ...state.propertyData,
                    six_part_file: payload
                }
            };

        case SET_PROPERTY_OLD_VALUE:
            return {
                ...state,
                oldValue: payload
            };

        case REMOVE_PROPERTY_OLD_VALUE:
            return {
                ...state,
                oldValue: ""
            };
        default:
            return state;
    }
}
